import { AgGridReact } from "ag-grid-react";
import React, { useState } from "react";
import { useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import * as commondata from "../../Common";
import CustomStatusBar from "./CustomStatusBar";
import moment from "moment";
import Modal from "../UI/modal/Modal";
import { Button, Message } from "../UI";
import { useRef } from "react";
import CustomFilter from "./CustomFilter";
import { StatusCellRenderer } from "../Board/cellrenderer/StatusCellRenderer";
import PeopleCellRenderer from "../Board/cellrenderer/PeopleCellRenderer";
import { getBoardHistory } from "../../Actions/update-single-row";
import DateTimeDisplay from "../../utils/TimeZoneDisplay";
import ApiCellRenderer from "../Board/cellrenderer/ApiCellRenderer";
import EffortCellRenderer from "../Board/cellrenderer/EffortCellRenderer";
import { convertTime } from "../../utils/convertTime";

const RelateEr = (props) => {
  const para = useParams();
  const dispatch = useDispatch();
  let menuButton = useRef(null);
  let griddapi = useRef(null);
  const [state, setState] = useState({
    columns: [],
    showModal: false,
    relation_uuid: "",
    confirmDelete: false,
    filterKeys: [],
    filterObj: {},
    users: {},
    filterDataRow: [],
    relationType: [],
    createBoard: {
      board: false,
      title: "",
      message: "",
      position: "bottom-end",
      bg: "",
    },
    defaultCols: {
      autoHeight: true,
      editable: false,
      headerComponent: (params) => customerHeaderCall(params),
    },
    columnDefs: [
      {
        headerName: "Priority",
        field: "priority",
      },
    ],
    statusBar: {
      statusPanels: [
        {
          statusPanel: CustomStatusBar,
          statusPanelParams: {
            fullScreen: props.externalWindowViewCustomModal,
            closeFullScreen: props.closeCustomModalHandler,
            isFullScreenView: props.isFullScreenView,
          },
        },
      ],
    },
    pagination: true,
    rowData: [],
  });

  const onMenuClicked = (params, event) => {
    // console.log(param, params, "checkcheck");
    const classes = para.attribute_set_key;
    const check = document.querySelector(
      `.${classes} [col-id="${params.column.colId}"]`
    );
    params.showColumnMenu(check);
  };
  
  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        columns: props.relateColumnData,
        rowData: props.relateRowData,
        users: props.users,
      };
    });
  }, [props.relateColumnData, props.relateRowData, props.users]);
  
  const customerHeaderCall = (params) => {
    let sort = null;
    let menu = null;
    if (params.column.colDef.is_filter) {
      menu = (
        <div
          ref={(menuButton) => {
            menuButton = menuButton;
          }}
          className="customHeaderMenuButton"
          onClick={() => onMenuClicked(params, menuButton)}
        >
          <svg
            width="16"
            height="44"
            viewBox="0 0 16 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="filter-svg"
          >
            <path
              d="M1 18H15"
              stroke="#5C5F62"
              stroke-width="1.33"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M3.5 22H12.5"
              stroke="#5C5F62"
              stroke-width="1.33"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.5 26H9.5"
              stroke="#5C5F62"
              stroke-width="1.33"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      );
    }

    // Function to handle sorting
    const handleSortClick = () => {
      const currentSort = params.column.getSort(); // Get current sort state for this column
      let newSort;

      // Determine next sort order (cycle: ascending -> descending -> none)
      if (currentSort === "asc") {
        newSort = "desc";
      } else {
        newSort = "asc";
      }

      // Set the new sort state using the column API
      params.columnApi.applyColumnState({
        state: [{ colId: params.column.getColId(), sort: newSort }],
        applyOrder: true,
      });
    };

    if (params.column.colDef.sortable) {
      const currentSort = params.column.getSort();
      sort = (
        <span onClick={handleSortClick}>
          {" "}
          {currentSort === "asc" ? (
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 2.91671L7 11.0834"
                stroke="black"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.0835 7.00004L7.00016 11.0834L2.91683 7.00004"
                stroke="black"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          ) : (
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 11.0833V2.91663"
                stroke="black"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2.9165 6.99996L6.99984 2.91663L11.0832 6.99996"
                stroke="black"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          )}
        </span>
      );
    }

    return (
      <div className="customHeaderLabel">
        <div className="custom-header-checkbox">{params.displayName}</div>
        <div className="sort-menu">
          {" "}
          {sort}
          {menu}
        </div>{" "}
      </div>
    );
  };
  const getDateValue = (date) => {
    const parseDate = new Date(date);
    return !isNaN(parseDate) && parseDate.toString() != "invalid date";
  };
  const deleteRelateHandler = async (params) => {
    setState((state) => {
      return {
        ...state,
        showModal: true,
        relation_uuid: params.data.relation_uuid,
      };
    });
  };
  const filterRecords = (arr, data) => {
    let newdata;
    let newobj;

    const deepMatch = (itemValue, filterValue, key, item) => {
      if (
        (key.includes("start_date") ||
          key.includes("end_date") ||
          key.includes("go_live_date") ||
          key.includes("qa_end_date") ||
          key.includes("qa_start_date")) &&
        Array.isArray(filterValue) &&
        filterValue.length === 2
      ) {
        const itemDate = new Date(item[key]);
        const startDate = new Date(filterValue[0]);
        const endDate = new Date(filterValue[1]);
        // Compare dates
        return itemDate >= startDate && itemDate <= endDate;
      }
      // Check if filterValue is an object, and if so, match its nested keys
      if (
        filterValue &&
        typeof itemValue === "object" &&
        filterValue !== null
      ) {
        for (let nestedKey in itemValue) {
          // Check if itemValue is also an object and contains the nested key
          if (typeof itemValue === "object" && itemValue !== null) {
            if (
              itemValue["effort_in_days"] == filterValue ||
              itemValue["effort_in_hours"] == filterValue
            ) {
              return true;
            }
          }
        }
      }
      return typeof filterValue === "string" && typeof itemValue === "string"
        ? itemValue?.toLowerCase()?.includes(filterValue.toLowerCase())
        : itemValue == filterValue;
    };

    return arr.filter((item) => {
      for (let key in data) {
        if (data[key] !== undefined) {
          state.filterKeys.forEach((filterKey) => {
            const check = document.querySelector(`[col-id="${filterKey}"]`);
            if (check) {
              check
                .querySelectorAll(".filter-svg path")
                .forEach((ite) => (ite.style.stroke = "#18A0FB"));
            }
          });

          if (!deepMatch(item[key], data[key], key, item)) {
            return false;
          }
        } else {
          setTimeout(() => {
            const check = document.querySelector(`[col-id="${key}"]`);
            if (check) {
              check
                .querySelectorAll(".filter-svg path")
                .forEach((ite) => (ite.style.stroke = "grey"));
            } else {
              document
                .querySelectorAll(".filter-svg path")
                .forEach((ite) => (ite.style.stroke = "grey"));
            }
          });
          newdata = state.rowData;
          newobj = { ...delete data[key], ...data };
          setState((state) => {
            return {
              ...state,
              filterObj: newobj,
              filterKeys: [...Object.keys(newobj)],
              filterDataRow: newdata,
            };
          });
        }
      }
      return true;
    });
  };

  function isObjectNotBlank(obj) {
    return Object.keys(obj).length > 0;
  }
  useEffect(() => {
    if (isObjectNotBlank(state.filterObj)) {
      const filterdata = filterRecords(state.rowData, state.filterObj);

      setState((state) => {
        return {
          ...state,
          filterDataRow: filterdata,
        };
      });
    } else {
      setState((state) => {
        return {
          ...state,
          filterDataRow: state.rowData,
        };
      });
    }
  }, [state.filterObj, props.relateRowData]);
  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        relationType: props.relationType,
      };
    });
  }, [props.relationType]);
  const getFilterParams = (prs, data) => {
    setState((state) => {
      return {
        ...state,
        filterObj: { ...state.filterObj, ...data },
        filterKeys: [...Object.keys(data)],
      };
    });
  };

  useEffect(() => {
    (async () => {
      if (state.relation_uuid && state.confirmDelete) {
        const responsedata = await fetch(
          `${commondata.commonData().apiUrl}tattle/remove-relation`,
          {
            method: "POST",
            body: JSON.stringify({
              app_token: commondata.getCommonData().app_token,
              attribute_set_key: para.attribute_set_key,
              relation_uuid: state.relation_uuid,
              user_uuid: commondata.getCommonData().user_uuid,
              parent_attribute_set_key: props.parent_attribute_set_key,
            }),
          }
        );

        const rdata = await responsedata.json();
        if (rdata.code === 200) {
          setState((state) => {
            return {
              ...state,
              confirmDelete: false,
              showModal: false,
              filterDataRow: [],
              // createBoard: {
              //   ...state.createBoard,
              //   board: true,
              //   bg: "primary",
              //   title: "success",
              //   message: rdata.message,
              // },
            };
          });
          props.getCallRelatonFunc();
          const newhistory = await dispatch(
            getBoardHistory(
              {
                app_token: commondata.getCommonData().app_token,
                attribute_set_key: para.attribute_set_key,
                attribute_set_type: props.attribute_set_type,
                customer_tattle_uuid: Number(para.id),
              },
              "status"
            )
          );
          if (newhistory.code == 200) {
            props.getHistoryData(newhistory);
          }
        } else {
          setState((state) => {
            return {
              ...state,
              createBoard: {
                ...state.createBoard,
                board: true,
                bg: "danger",
                title: "error",
                message: rdata.message,
              },
            };
          });
        }
      }
    })();
  }, [state.relation_uuid, state.confirmDelete, props.getCallRelatonFunc]);
  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        filterDataRow: [],
      };
    });
  }, []);

  const deleteConfirmHandler = () => {
    setState((state) => {
      return {
        ...state,
        confirmDelete: true,
      };
    });
  };

  const closeModal = () => {
    setState((state) => {
      return {
        ...state,
        showModal: false,
      };
    });
  };

  useEffect(() => {
    setState((state) => {
      const relatedToColumn = !props.categoryBboardID
      ? [
      {
        headerName: "Related To",
        is_filter: true,
        field: "relation_name",
        width: 120,
        resizable: true,
        sortable: false,
        filter: CustomFilter,
        menuTabs: ["filterMenuTab"],
        filterParams: {
          filter: getFilterParams,
          values: state.relationType || [],
        },
      },
    ]
  : [];

      return {
        ...state,
        columnDefs: [
          {
            headerName: "ID",
            field: "customer_tattle_uuid",
            width: 80,
            sortable: true,
            is_filter: true,
            sort: "desc",
            resizable: true,
            filter: CustomFilter,
            menuTabs: ["filterMenuTab"],
            filterParams: {
              filter: getFilterParams,
            },
            cellRenderer: (param) => {
              return (
                <Link
                  to={`/tattle/${props.newAttributeSetKey ?? para.attribute_set_key}/${param.data.customer_tattle_uuid}`}
                  className="childlink"
                  target="_blank"
                >
                  {param.data.customer_tattle_uuid}
                </Link>
              );
            },
          },
          {
            headerName: "Title",
            field: "title",
            is_filter: true,
            resizable: true,
            width: 230,
            filter: CustomFilter,
            menuTabs: ["filterMenuTab"],
            filterParams: {
              filter: getFilterParams,
            },
          },

          ...state.columns
            ?.filter((item) => {
              if (item.field !== "title")
                return {
                  headerName: item.headerName,
                  field: item.field,
                };
            })
            .map((itt) => {
              if (itt.attribute_type === "status") {
                const { options } = itt;
                return {
                  headerName: "Status",
                  field: "status",
                  is_filter: true,
                  ...itt,
                  menuTabs: ["filterMenuTab"],
                  width: 120,
                  editable: false,
                  resizable: true,
                  sortable: false,
                  filter: CustomFilter,
                  filterParams: {
                    filter: getFilterParams,
                  },
                  cellRenderer: StatusCellRenderer,
                };
              }
              if (itt.attribute_type === "assign_to") {
                const { options } = itt;
                return {
                  headerName: "Status",
                  field: "status",
                  is_filter: true,
                  ...itt,
                  width: 120,
                  resizable: true,
                  editable: false,
                  sortable: false,
                  menuTabs: ["filterMenuTab"],
                  filter: CustomFilter,
                  filterParams: {
                    filter: getFilterParams,
                    users: state.users,
                  },
                  cellRenderer: PeopleCellRenderer,
                  cellRendererParams: { users: state.users },
                };
              }
              if (itt.attribute_type === "api") {
                const { options } = itt;
                return {
                  headerName: "Status",
                  field: "status",
                  is_filter: true,
                  ...itt,
                  editable: false,
                  width: 160,
                  resizable: true,
                  sortable: false,
                  menuTabs: ["filterMenuTab"],
                  filter: CustomFilter,
                  filterParams: {
                    filter: getFilterParams,
                    users: state.users,
                  },
                  cellRenderer: ApiCellRenderer,
                  cellRendererParams: { users: state.users },
                };
              }
              if (itt.attribute_type == "start_date") {
                return {
                  headerName: itt.headerName,
                  is_filter: true,
                  ...itt,
                  width: 150,
                  is_filter: true,
                  resizable: true,
                  sortable: false,
                  editable: false,
                  filter: CustomFilter,
                  menuTabs: ["filterMenuTab"],
                  cellRenderer: (params) => {
                    return params.value === "0000-00-00" ? "" : params.value;
                  },
                  filterParams: {
                    filter: getFilterParams,
                    values: state.relationType || [],
                  },
                };
              }

              if (itt.attribute_type == "effort") {
                return {
                  headerName: itt.headerName,
                  is_filter: true,
                  field: itt.field,
                  is_filter: true,
                  ...itt,
                  width: 120,
                  resizable: true,
                  sortable: false,
                  editable: false,
                  filter: CustomFilter,
                  menuTabs: ["filterMenuTab"],
                  cellRenderer: EffortCellRenderer,
                  filterParams: {
                    filter: getFilterParams,
                    values: state.relationType || [],
                  },
                };
              }
              if (itt.attribute_type == "end_date") {
                return {
                  headerName: itt.headerName,
                  is_filter: true,
                  field: itt.field,
                  ...itt,
                  is_filter: true,
                  editable: false,
                  sortable: false,
                  width: 150,
                  resizable: true,
                  filter: CustomFilter,
                  cellRenderer: (params) => {
                    return params.value === "0000-00-00" ? "" : params.value;
                  },
                  menuTabs: ["filterMenuTab"],
                  filterParams: {
                    filter: getFilterParams,
                    values: state.relationType || [],
                  },
                };
              }
              if (itt.attribute_type == "go_live_date") {
                return {
                  headerName: itt.headerName,
                  is_filter: true,
                  field: itt.field,
                  ...itt,
                  is_filter: true,
                  width: 120,
                  sortable: false,
                  resizable: true,
                  editable: false,
                  filter: CustomFilter,
                  cellRenderer: (params) => {
                    return params.value === "0000-00-00" ? "" : params.value;
                  },
                  menuTabs: ["filterMenuTab"],
                  filterParams: {
                    filter: getFilterParams,
                    values: state.relationType || [],
                  },
                };
              }
              if (itt.attribute_type === "category") {
                const { options } = itt;
                return {
                  headerName: itt.headerName,
                  field: "category",
                  ...itt,
                  is_filter: true,
                  editable: false,
                  menuTabs: ["filterMenuTab"],
                  filter: CustomFilter,
                  width: 120,
                  sortable: false,
                  resizable: true,
                  filterParams: {
                    filter: getFilterParams,
                  },
                  cellRenderer: (param) => {
                    return Array.isArray(param.value)
                      ? options.find((it) => param.value.includes(it._id))?.name
                      : options.find((it) => it._id === param.value)?.name;
                  },
                };
              }
              if (itt.attribute_type === "release") {
                const { options } = itt;

                return {
                  headerName: itt.headerName,
                  field: "release",
                  ...itt,
                  is_filter: true,
                  editable: false,
                  menuTabs: ["filterMenuTab"],
                  filter: CustomFilter,
                  width: 120,
                  sortable: false,
                  resizable: true,
                  filterParams: {
                    filter: getFilterParams,
                  },
                  cellRenderer: (param) => {
                    return options.find((it) => it.id === param.value)?.value;
                  },
                };
              }
              if (itt.attribute_type === "priority") {
                const { options } = itt;
                return {
                  headerName: "Priority",
                  is_filter: true,
                  field: "priority",
                  ...itt,
                  width: 120,
                  resizable: true,
                  sortable: false,
                  editable: false,
                  menuTabs: ["filterMenuTab"],
                  filter: CustomFilter,
                  filterParams: {
                    filter: getFilterParams,
                  },

                  cellRenderer: (param) => {
                    return Array.isArray(param.value)
                      ? options.find((it) => param.value.includes(it._id))
                          ?.option_name
                      : options.find((it) => it._id === param.value)
                          ?.option_name;
                  },
                };
              }
              return itt;
            }),
            
            ...relatedToColumn,
          {
            headerName: "Updated",
            field: "updated_timestamp",
            sortable: false,
            attribute_type: "timestamp",
            resizable: true,
            width: 120,
            cellRenderer: (params) => {
              return (
                <>
                  <DateTimeDisplay dateTime={params.value} />
                </>
              );
            },
          },
          {
            headerName: "Action",
            width: 90,
            cellRenderer: (params) => {
              return (
                <span
                  onClick={() => deleteRelateHandler(params)}
                  className="deleterelateer"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 4H3.33333H14"
                      stroke="#5C5F62"
                      stroke-width="1.33"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M5.33301 3.99992V2.66659C5.33301 2.31296 5.47348 1.97382 5.72353 1.72378C5.97358 1.47373 6.31272 1.33325 6.66634 1.33325H9.33301C9.68663 1.33325 10.0258 1.47373 10.2758 1.72378C10.5259 1.97382 10.6663 2.31296 10.6663 2.66659V3.99992M12.6663 3.99992V13.3333C12.6663 13.6869 12.5259 14.026 12.2758 14.2761C12.0258 14.5261 11.6866 14.6666 11.333 14.6666H4.66634C4.31272 14.6666 3.97358 14.5261 3.72353 14.2761C3.47348 14.026 3.33301 13.6869 3.33301 13.3333V3.99992H12.6663Z"
                      stroke="#5C5F62"
                      stroke-width="1.33"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M6.66699 7.33325V11.3333"
                      stroke="#5C5F62"
                      stroke-width="1.33"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M9.33301 7.33325V11.3333"
                      stroke="#5C5F62"
                      stroke-width="1.33"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </span>
              );
            },
          },
        ],
      };
    });
  }, [
    state.columns,
    state.relationType,
    state.rowData,
    props.relateRowData,
    props.relateColumnData,
  ]);
  const handleProcessCellForClipboard = (params) => {
    const { colDef } = params?.column;

    const type = colDef?.attribute_type;

    switch (type) {
      case "assign_to":
      case "reporter":
      case "people":
        return state.users[params.value]?.name;
        break;
      case "monitoring":
        return (params.value || [])
          .map((item) => state.users[item]?.name)
          .join(", ");
        break;
      case "tse_owner":
      case "account_manager":
      case "sales_manager": {
        const { options } = colDef;

        const val = options?.data?.find(
          (item) => (item._id || item?.user_uuid) === params.value
        );

        return val?.option_name || val?.name || val?.value;
      }

      case "priority":
      case "category":
      case "status":
      case "api":
      case "release":
      case "select":
      case "product": {
        const { options } = colDef;

        const val = options?.find(
          (item) => (item._id || item.id) === params.value
        );
        return val?.option_name || val?.name || val?.value;
      }

      case "effort":
        let day = params?.value?.effort_in_days;
        let hour = params?.value?.effort_in_hours;

        let effort;

        if (day) {
          if (day > -10 && day < 10) {
            effort = `0${day}D `;
          } else {
            effort = `${day}D `;
          }
        } else {
          effort = "";
        }

        if (hour) {
          if (hour > -10 && hour < 10) {
            effort += `0${hour}D`;
          } else {
            effort += `${hour}D`;
          }
        } else {
          effort += "";
        }

        return effort;
        break;
      case "timestamp":
        return convertTime(params.value);
        break;
      default:
        return params.value;
        break;
    }
  };
  const onGridReady = (params) => {
    griddapi.current = params.api;
    params.api.sizeColumnsToFit();
    // params.api.setQuickFilter('test');
  };

  useEffect(() => {
    if (griddapi.current) {
      griddapi.current.setQuickFilter(props.globalSearch?props.globalSearch:"");
    }
  }, [props.globalSearch]);
  return (
    <>
      {state.createBoard.board && <Message board={state.createBoard} />}
      <Modal show={state.showModal} className="confirm" close={closeModal}>
        <div className="deleteAlert">
          <p>Are you sure you want delete?</p>
          <div className="actionDelete">
            <Button
              className="muBtn _blue"
              text="Yes"
              onClick={() => deleteConfirmHandler()}
            />{" "}
            &nbsp;
            <Button
              className="muBtn _grey"
              text="Cancel"
              onClick={closeModal}
            />
          </div>
        </div>
      </Modal>
      <div
        className={`ag-theme-alpine ag-theme-bootstrap ${para.attribute_set_key}`}
        style={{ height: 350, width: "100%" }}
      >
        <AgGridReact
          columnDefs={state.columnDefs}
          rowData={
            state.filterDataRow.length > 0 ||
            Object.keys(state.filterObj).length > 0
              ? state.filterDataRow
              : state.rowData
          }
          defaultColDef={state.defaultCols}
          pagination={true}
          suppressContextMenu={true}
          paginationPageSize={20}
          enableRangeSelection={true}
          copyHeadersToClipboard={true}
          statusBar={state.statusBar}
          processCellForClipboard={handleProcessCellForClipboard} // Customize cell copy
          // frameworkComponents={{
          //   customStatusBar: CustomStatusBar,
          // }}
          onGridReady={onGridReady}
          suppressPaginationPanel={true}
        />
      </div>
    </>
  );
};

export default RelateEr;
